module.exports = __webpack_public_path__ + "img/mv.40ec63ff.svg";